import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { BookService } from 'src/app/shared/book.service';
import { Router } from '@angular/router';
import * as $ from "jquery";

declare let alertify : any;
declare let localforage : any;
declare let window : any;

@Component({
	selector: 'app-quiz-category-detail',
	templateUrl: './quiz-category-detail.component.html',
	styleUrls: ['./quiz-category-detail.component.scss']
})
export class QuizCategoryDetailComponent implements OnInit {
	page : number = 1;
	quizDetail! : [];
	biletcategory! : [];
	allBiletkeywords! : any[];
	biletkeywordSelected! : any;
	currentBiletkeywords! : any;
	idBiletkeyword! : any;
	currentBiletkeywordSelected! : [];
	numberOfKeyword! : number;
	listQuiz : any[] = [];
	indexQuizItem : number = 0;
	quizItem : any = { level: 10 };
	listBook! : any[];
	urlImage! : string;
	urlImage2! : string;
	resultLevel0 : number = 0; // result = 1 => Đúng; result = 2 => Sai; result = 0 => Chuyển tiếp quiz
	resultLevel1 : number = 0;
	resultLevel2 : number = 0;
	resultLevel3 : number = 0;
	checkOrNextLevel0 : number = 0; //checkOrNextLevel0 = 0: button hiện tại là Kiểm tra, else button hiện tại là Tiếp tục
	checkOrNextLevel1 : number = 0;
	checkOrNextLevel2 : number = 0;
	checkOrNextLevel3 : number = 0;

	chooseAnsLevel0! : any;
	chooseAnsLevel1! : any;
	chooseAnsLevel2! : any;
	chooseAnsLevel3! : any;

	answerCorrect! : string;
	questionLevel2! : string;
	radioSelectedLevel1! : string;
	totalCorrect : number = 0;
	btnRetry : boolean = false;
	completedQuiz : boolean = false;

	constructor(private route : ActivatedRoute, private service : BookService, private router : Router) { }

	ngOnInit() : void {
		const code = this.route.snapshot.paramMap.get("code");
		var booksOnline = this.service.getBooks();
		var products : any = (booksOnline as any).default;
		var listItem = [];
		for (const property in products) {
			listItem.push(products[property]);
		}
		this.listBook = listItem.map((item, index) => {
			var biletkeyword = item.biletkeywords;
			var keyword1 : string;
			var keyword2 : string;
			var book : string;
			var category : string;
			biletkeyword.forEach((it : any, idx : number) => {
				keyword1 = it.keyword1.keyword_en;
				keyword2 = it.keyword2.keyword_en;
				book = item.code;
				category = it.category;
				this.urlImage = this.imageProcessKeyword(
					keyword1,
					book + "/image/" + category + "/"
				);
				this.urlImage2 = this.imageProcessKeyword(
					keyword2,
					book + "/image/" + category + "/"
				);
				it.keyword1.urlKeyword = this.urlImage;
				it.keyword2.urlKeyword = this.urlImage2;
			});
			item.biletcategory.forEach((o : any, idx : number) => {
				var urlIm = this.imageProcessKeyword(o.id, book + "/image/" + "/");
				item.biletcategory[idx].url = urlIm;
				item.biletcategory[
					idx
				].background 
					//= window.__static + `/static/${item.code}/image/background_stretch.png`;
					= window['__cdn_static'] + `${item.code}/image/background_stretch.png`;
			});

			return {
				...item,
				biletcategory: item.biletcategory,
			};
		});
		this.quizDetail = this.listBook.find(x => x.code === code);
		this.biletcategory = this.listBook.find(x => x.code === code).biletcategory;
		this.allBiletkeywords = this.listBook.find(x => x.code === code).biletkeywords;
		this.biletkeywordSelected = this.allBiletkeywords[0];
		this.getNumberOfKeyword(1);
	}
	
	getCdnImage(url : string) {
		let s = url || '';
		let fix = 'http://static.bilet.vn/static/';
		if (s.length > fix.length)
			s = window['__cdn_static'] + s.substr(fix.length);
		console.log(s);
		return s;
	}
	
	pageChanged(event : number) {
		this.page = event;
		this.getNumberOfKeyword(this.page);
		this.indexQuizItem = 0;
		this.startQuiz();
	}
	getNumberOfKeyword(page : number) {
		var listKey : any = [];
		this.currentBiletkeywordSelected = [];
		this.currentBiletkeywords = this.biletcategory[page - 1];
		this.idBiletkeyword = this.currentBiletkeywords.id;
		this.biletkeywordSelected = this.allBiletkeywords.map((a : any) => {
			if (a.category === this.idBiletkeyword) {
				listKey.push(a);
			}
		});
		this.currentBiletkeywordSelected = listKey;
		this.numberOfKeyword = this.currentBiletkeywordSelected.length;
	}

	imageProcessKeyword(filename : string, sourcefolder : string) {
		var lowerfilename = filename;
		lowerfilename = lowerfilename.toLocaleLowerCase();

		var newfilename = lowerfilename;
		if (newfilename.indexOf(" ") >= 0) {
			newfilename = newfilename.replace(/ /g, "_");
		} else if (filename.indexOf("/") >= 0) {
			newfilename = filename.replace("/", "-");
		} else if (filename.indexOf("'") >= 0) {
			newfilename = filename.replace("'", "_");
		}
		//var url = window.__static + `/static/${sourcefolder}${newfilename}.png`;
		var url = window['__cdn_static'] + `${sourcefolder}${newfilename}.png`;
		return url;
	}

	// Level 1
	onRadioChange(item : any) {
		this.chooseAnsLevel1 = item;
	}

	//Level 2
	onClickVolumeIcon(value : number) {
		this.speechSynthesis(this.quizItem.question.text_en);
	}

	startQuiz() {
		this.listQuiz = [];
		var allKeywords : any[] = [];
		var numberKeyRandom ! : number;

		var arrList : any = [];

		// Reset value
		this.totalCorrect = 0;
		this.indexQuizItem = 0;
		this.indexQuizItem++;
		numberKeyRandom = Math.floor(Math.random() * 19);
		this.currentBiletkeywordSelected.map((a : any) => {
			allKeywords.push(a.keyword1);
			allKeywords.push(a.keyword2);
		})
		while (arrList.length < 20) {
			var r = Math.floor(Math.random() * 20);
			if (arrList.indexOf(r) === -1) {
				if (r < allKeywords.length) {
					arrList.push(r);
				} else {
					arrList.push(r % allKeywords.length);
				}
			}
		}
		// Random level trong câu hỏi
		for (var i = 0; i < arrList.length; i++) {
			var itWord = allKeywords[arrList[i]];
			this.listQuiz.push(itWord);
		}
		this.listQuiz.forEach((item, index) => {
			var arrayLevel = [0, 1, 3];
			var numberLevelRandom = Math.floor(Math.random() * 3);
			item.level = arrayLevel[numberLevelRandom];
			// Câu hỏi
			item.question = {
				text_en: item.keyword_en,
				text_vn: item.keyword_vn,
				image: item.keyword_en,
				urlKeyword: item.urlKeyword,
			}
			// Câu trả lời
			switch (item.level) {
				case 0:
				case 1:
				case 3:
					var listAnswer : any = [];
					var answers : any = [];
					var lstAnswer = [];
					var arr : any = [];
					var numberLevelRandomAnswer! : number;
					var resultFilter = this.listQuiz.filter(it => it.keyword_en !== item.keyword_en);
					while (lstAnswer.length < 3) {
						var r = Math.floor(Math.random() * resultFilter.length);
						if (lstAnswer.indexOf(r) === -1) lstAnswer.push(r);
					}
					// Tạo danh sách answer
					for (var i = 0; i < lstAnswer.length; i++) {
						var itAnswer : any = {};
						var arrayLevel = [0, 1, 3];
						numberLevelRandomAnswer = Math.floor(Math.random() * 3);
						itAnswer.level = arrayLevel[numberLevelRandomAnswer];
						itAnswer.keyword_en = resultFilter[lstAnswer[i]].keyword_en;
						itAnswer.keyword_vn = resultFilter[lstAnswer[i]].keyword_vn;
						itAnswer.howto_en = resultFilter[lstAnswer[i]].howto_en;
						itAnswer.spelling_en = resultFilter[lstAnswer[i]].spelling_en;
						itAnswer.urlKeyword = resultFilter[lstAnswer[i]].urlKeyword;
						answers.push(itAnswer);
					}
					var anserQuestion = {
						level: item.level,
						keyword_en: item.keyword_en,
						keyword_vn: item.keyword_vn,
						howto_en: item.howto_en,
						spelling_en: item.spelling_en,
						urlKeyword: item.urlKeyword
					}
					answers.push(anserQuestion);
					// đảo vị trí của item trong mảng answer
					while (arr.length < 4) {
						var r = Math.floor(Math.random() * 4);
						if (arr.indexOf(r) === -1) arr.push(r);
					}
					for (var i = 0; i < arr.length; i++) {
						listAnswer.push(answers[arr[i]]);
					}
					item.answer = listAnswer;
					break;
				// case 2:
				//   this.questionLevel2 = item.question.text_en;
				//   break;
			}
		});
		this.quizItem = this.listQuiz[0];
		if (this.quizItem.level === 2 || this.quizItem.level === 3) {
			this.speechSynthesis(this.quizItem.question.text_en);
		}
	}

	chooseAnswer(level : number, item : any, event : any) {
		switch (level) {
			case 0:
				this.chooseAnsLevel0 = item;
				break;
			case 3:
				this.chooseAnsLevel3 = item;
				break;
		}

		if ($(event.target)[0].nodeName === "IMG" || $(event.target)[0].nodeName === 'P') {
			// remove class active
			$('.quiz-category ul li').removeClass('active-choose');
			//active class khi user chọn đáp án
			$(event.target.parentElement).addClass('active-choose');
		}
	}

	changeQuestion() {
		this.indexQuizItem = this.indexQuizItem + 1;
		if (this.indexQuizItem <= this.listQuiz.length) {
			this.quizItem = this.listQuiz[this.indexQuizItem - 1];
		} else {
			if (this.totalCorrect <= 10) {
				this.btnRetry = true;
				this.completedQuiz = false;
				this.indexQuizItem = 0;
			} else {
				this.completedQuiz = true;
				this.btnRetry = true;
			}
		}
		if (this.quizItem) {
			if (this.quizItem.level === 2 || this.quizItem.level === 3) {
				this.speechSynthesis(this.quizItem.question.text_en);
			}
		}
	}

	retryQuestion() {
		this.btnRetry = false;
		this.startQuiz();
	}

	speechSynthesis(text : string) {
		if ("speechSynthesis" in window) {
			var msg = new SpeechSynthesisUtterance();
			msg.text = text;
			window.speechSynthesis.speak(msg);
		} else {
			console.log("Don't support speechSynthesis");
		}
	}

	btnCheck(value : number) {
		switch (value) {
			case 0: // level = 0
				if (this.checkOrNextLevel0 === 0) { // Nhấn button Kiểm tra
					if (this.chooseAnsLevel0 && this.chooseAnsLevel0.keyword_en === this.quizItem.question.text_en) {
						this.resultLevel0 = 1;
						this.totalCorrect++;
					} else {
						this.answerCorrect = this.quizItem.question.text_vn;
						this.resultLevel0 = 2;
					}
					this.checkOrNextLevel0++;
				} else { // Nhấn button Tiếp tục
					this.checkOrNextLevel0 = 0;
					this.resultLevel0 = 0;
					this.changeQuestion();
				}
				break;
			case 1: //level 1
				if (this.checkOrNextLevel1 === 0) {
					if (this.chooseAnsLevel1 && this.chooseAnsLevel1.keyword_en === this.quizItem.question.text_en) {
						this.resultLevel1 = 1;
						this.totalCorrect++;
					} else {
						this.answerCorrect = this.quizItem.question.text_en;
						this.resultLevel1 = 2;
					}
					this.checkOrNextLevel1++;
				} else {
					this.checkOrNextLevel1 = 0;
					this.resultLevel1 = 0;
					this.changeQuestion();
				}
				break;
			case 2:
				this.chooseAnsLevel2 = $('#txtAnswerLevel2').val();
				if (this.checkOrNextLevel2 === 0) {
					if (this.chooseAnsLevel2.toLowerCase() === this.quizItem.question.text_en.toLowerCase()) {
						this.resultLevel2 = 1;
						this.totalCorrect++;
					} else {
						this.answerCorrect = this.quizItem.question.text_en;
						this.resultLevel2 = 2;
					}
					this.checkOrNextLevel2++;
				} else {
					this.checkOrNextLevel2 = 0;
					this.resultLevel2 = 0;
					$('#txtAnswerLevel2').val("");
					this.changeQuestion();
				}
				break;
			case 3: //level 3
				if (this.checkOrNextLevel3 === 0) {
					if (this.chooseAnsLevel3 && this.chooseAnsLevel3.keyword_en === this.quizItem.question.text_en) {
						this.resultLevel3 = 1;
						this.totalCorrect++;
					} else {
						this.answerCorrect = this.quizItem.question.text_vn;
						this.resultLevel3 = 2;
					}
					this.checkOrNextLevel3++;
				} else {
					this.checkOrNextLevel3 = 0;
					this.resultLevel3 = 0;
					this.changeQuestion();
				}
				break;
		}

	}
}